import { FETCH_USER_ACTIVITY_LOGS, COMPANY_USERS, UPDATE_INITIAL_FILTERS, UPDATE_FILTERS } from "../actions/userActivityLogsAction";
import { formatUserActivityData } from "../components/SettingsContainer/UserActivity/utils/userActivityLogsUtils";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { initialDuration, initialFilterRefineFilter } from "../components/SettingsContainer/UserActivity/UserActivity";

const initialFilters = {
    duration: "7",
    startDateTime: null,
    endDateTime: null,
    rollingDate: false,
};

const initalState = {
    userActivityLists: [],
    pages: 0,
    paginationFetch: false,
    userActivityListLoading: false,
    userActivityListError: null,
    filters: initialFilters,
    // duration: initialDuration,
    filterRefineFilter: initialFilterRefineFilter,
    filterUpdated: 0,
    companyUsersLoading: false,
    companyUsers: {},
};

const userActivityLogsReducer = (state = initalState, action) => {
    switch (action.type) {
        case isPending(FETCH_USER_ACTIVITY_LOGS):
            return { ...state, userActivityListLoading: true, userActivityListError: null };

        case isFulfilled(FETCH_USER_ACTIVITY_LOGS): {
            let userActivityLists;
            if (action.payload.pagination) {
                userActivityLists = [...state.userActivityLists, ...formatUserActivityData(action.payload.docs)];
            } else {
                userActivityLists = formatUserActivityData(action.payload.docs);
            }
            return {
                ...state,
                userActivityLists: userActivityLists,
                pages: action.payload.total_doc,
                paginationFetch: action.payload.pagination,
                userActivityListLoading: false,
                userActivityListError: null,
            };
        }

        case isRejected(FETCH_USER_ACTIVITY_LOGS):
            return { ...state, userActivityLists: [], userActivityListLoading: false, userActivityListError: true }; //action.payload

        case UPDATE_INITIAL_FILTERS:
            return {
                ...state,
                // filters: {
                //     ...state.filters,
                //     duration: action.payload.duration || initialDuration,
                // },
                // duration: action.payload.duration || initialDuration,
                filters: action.payload.filters || initialFilters,
                filterRefineFilter: action.payload.filterRefineFilter || initialFilterRefineFilter,
                filterUpdated: state.filterUpdated + 1,
            };

        // case "UPDATE_DURATION":
        //     return { ...state, duration: action.payload || initialDuration, filterUpdated: state.filterUpdated + 1, userActivityLists: [] };

        case UPDATE_FILTERS:
            return {
                ...state,
                filterRefineFilter: action.payload.filterRefineFilter || initialFilterRefineFilter,
                filters: action.payload.filters || initialFilters,
                filterUpdated: state.filterUpdated + 1,
                userActivityLists: [],
                pages: 0,
            };

        case isPending(COMPANY_USERS):
            return { ...state, companyUsersLoading: true };

        case isFulfilled(COMPANY_USERS): {
            const users = {};
            action.payload?.forEach((user) => {
                users[user.lite_id] = user;
            });

            return { ...state, companyUsers: users, companyUsersLoading: false };
        }

        case isRejected(COMPANY_USERS):
            return { ...state, companyUsersLoading: false };

        // case CLEANUP_USER_ACTIVITY:
        //     return { ...initalState };

        default:
            return state;
    }
};
export default userActivityLogsReducer;
